/** `/associations`: the user's access-group associations (the location-edit "Access" section's option list). */
const ASSOCIATIONS_RESPONSE = { associations: [] };

export { ASSOCIATIONS_RESPONSE };
